import GaugeEdit from './GaugeEdit'

export default GaugeEdit;